var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabItem1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "url(#paint0_linear_67_6434)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1111 31.1111L17.4802 24.7419C18.565 23.6572 20.3239 23.6572 21.4086 24.7419L25.8136 29.1469C26.8983 30.2317 28.6572 30.2317 29.7419 29.1469L38.8889 20M38.8889 20V26.9444V20ZM38.8889 20H31.9444H38.8889Z",
    fill: "url(#paint1_linear_67_6434)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1111 31.1111L17.4802 24.7419C18.565 23.6572 20.3239 23.6572 21.4086 24.7419L25.8136 29.1469C26.8983 30.2317 28.6572 30.2317 29.7419 29.1469L38.8889 20M38.8889 20V26.9444M38.8889 20H31.9444",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_67_6434",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABB04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_67_6434",
    x1: 25,
    y1: 20,
    x2: 25,
    y2: 31.1111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABB04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabItem1);
export default __webpack_public_path__ + "static/media/tab_item-1.c76a33c47ae6be9170b35801644ce71d.svg";
export { ForwardRef as ReactComponent };